import { render, staticRenderFns } from "./AbkAdditionalDates.vue?vue&type=template&id=d54dffc8&scoped=true&"
import script from "./AbkAdditionalDates.vue?vue&type=script&lang=js&"
export * from "./AbkAdditionalDates.vue?vue&type=script&lang=js&"
import style0 from "./AbkAdditionalDates.vue?vue&type=style&index=0&id=d54dffc8&scoped=true&lang=scss&"
import style1 from "./AbkAdditionalDates.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54dffc8",
  null
  
)

export default component.exports